import DaoBase from "./base";
import {rd} from "../../vars/rd";
import {$shutils} from "../../libs/snnh/snnh";
import {proxyBy} from "../func";

class DaoChannel extends DaoBase {
    best;
    channelid;
    favorite;
    genre;
    groupid;
    image;
    info;
    moddate;
    radio_url;
    regdate;
    subtitle;
    tempo;
    theme;
    title;
    type;
    view_title;

    headline;

    /** @property {{number: string}} */
    business;

    constructor(json=null) {
        super(json);

        const business = {};

        if(json && json.hasOwnProperty('business')) {
            (json.business || []).forEach(category => {
                business[category.proid] = category.code;
            });
        }
        this.business = business;

        // 기본값
        if(!this.theme) this.theme = 1;
    }

    get imageProxy() {
        return proxyBy(this.image)
    }

    /**
     * 기간내에 수정/등록 여부
     * @returns {boolean}
     */
    get isNew() {
        try {
            const dateGap = new Date().getTime() - $shutils.toDate(this.moddate || this.regdate).getTime();
            return dateGap - (rd.channel_new * 86400 * 1000) < 0;
        } catch (e) {}
        return false;
    }

    get isBest() {
        return this.best === 'Y';
    }

    get isFavorite() {
        return this.favorite === 'Y';
    }

    /**
     *
     * @returns {DaoCategory[]}
     */
    get businessCategory() {
        const results = [];
        const codes = Object.values(this.business);
        if(codes && codes.length > 0) {
            /** @type DaoCategory[] */
            const categories = (rd.category.business || []);
            categories.forEach(category => {
                if(codes.indexOf(category.code) !== -1) {
                    results.push(category);
                }
            });
        }
        return results;
    }

    /**
     * 장르카테고리
     * @returns {DaoCategory|null}
     */
    get genreCategory() {
        let c = null;
        /** @type DaoCategory[] */
        const categories = (rd.category.genre || []);
        categories.forEach(category => {
            if(Number(this.genre) === Number(category.proid)) c = category;
        });
        return c;
    }

    /**
     * 테마카테고리
     * @returns {DaoCategory|null}
     */
    get themeCategory() {
        let c = null;
        /** @type DaoCategory[] */
        const categories = (rd.category.theme || []);
        categories.forEach(category => {
            if(Number(this.theme) === Number(category.proid)) c = category;
        });
        return c;
    }

    /**
     * 템포카테고리
     * @returns {DaoCategory|null}
     */
    get tempoCategory() {
        let c = null;
        /** @type DaoCategory[] */
        const categories = (rd.category.tempo || []);
        categories.forEach(category => {
            if(Number(this.tempo) === Number(category.proid)) c = category;
        });
        return c;
    }

    clone() {
        const _clone = new DaoChannel();
        _clone.best = this.best;
        _clone.channelid = this.channelid;
        _clone.favorite = this.favorite;
        _clone.genre = this.genre;
        _clone.groupid = this.groupid;
        _clone.image = this.image;
        _clone.info = this.info;
        _clone.moddate = this.moddate;
        _clone.radio_url = this.radio_url;
        _clone.regdate = this.regdate;
        _clone.subtitle = this.subtitle;
        _clone.tempo = this.tempo;
        _clone.theme = this.theme;
        _clone.title = this.title;
        _clone.type = this.type;
        _clone.view_title = this.view_title;
        _clone.headline = this.headline;
        _clone.business = this.business;
        return _clone;
    }
}

export default DaoChannel;


// WEBPACK FOOTER //
// ./src/modules/dao/channel.js